import React from "react";
import * as cl from "./BillingPeriodTabs.module.css"
import classnames from "classnames";

export const BillingPeriodTabs = ({ monthly, yearly, isYearly, onChange }) => {
  return (
    <div className={cl.tabsRow}>
      <div onClick={() => onChange(true)} className={classnames(cl.label, { [cl.borderHidden]: !isYearly})}>{yearly}</div>
      <div onClick={() => onChange(false)} className={classnames(cl.label, { [cl.borderHidden]: isYearly})}>{monthly}</div>
    </div>
  )
} 